(() => {
  function update(scope, productId, variantId) {
    const mapElement = scope.querySelector(`[data-zentrobad-title-map="${productId}"]`);
    if (!mapElement) return;
    let titles;
    try { titles = JSON.parse(mapElement.textContent); } catch { return; }
    const title = titles?.[String(variantId)]?.replace(/\s+Zentrobad\s*$/i, '');
    if (!title) return;
    const series = title.match(/^(Avera|Vario)\s/)?.[1];
    if (series) document.querySelectorAll(`[data-zentrobad-series="${productId}"]`).forEach(element => { element.textContent = series; });
    scope.querySelectorAll(`[data-zentrobad-variant-title="${productId}"]`).forEach(element => {
      element.textContent = title;
      if (element.tagName === 'H1' && !element.closest('quick-add-dialog, product-card')) {
        document.title = title;
        const breadcrumb = document.querySelector('.zentrobad-breadcrumbs__current');
        if (breadcrumb) breadcrumb.textContent = title;
      }
    });
  }

  document.addEventListener('variant:update', event => {
    const scope = event.target.closest('product-card, .shopify-section');
    const productId = event.detail?.data?.productId;
    const variantId = event.detail?.resource?.id;
    if (scope && productId && variantId) update(scope, productId, variantId);
    const updatedHtml = event.detail?.data?.html;
    if (scope && productId && updatedHtml?.querySelector) {
      for (const className of ['zentrobad-dimensions-summary', 'zentrobad-specs--compact', 'zentrobad-specs--media']) {
        const selector = `.${className}[data-zentrobad-dimensions-product="${productId}"]`;
        const current = scope.querySelector(selector);
        const next = updatedHtml.querySelector(selector);
        if (current && next) current.replaceWith(next.cloneNode(true));
      }
    }
  }, true);

  const heading = document.querySelector('main h1[data-zentrobad-variant-title]');
  if (heading) {
    document.title = heading.textContent.trim();
    const breadcrumb = document.querySelector('.zentrobad-breadcrumbs__current');
    if (breadcrumb) breadcrumb.textContent = heading.textContent.trim();
    const series = heading.textContent.trim().match(/^(Avera|Vario)\s/)?.[1];
    if (series) document.querySelectorAll(`[data-zentrobad-series="${heading.dataset.zentrobadVariantTitle}"]`).forEach(element => { element.textContent = series; });
  }
})();
